import type { QueryFunctionContext } from '@tanstack/react-query';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { TCall } from 'app/queries/types/TCall';
import { superEnhancementApi } from './superEnhancementApi';
import { superEnhancementKeys } from './superEnhancementKeys';

export const createFetchSuperEnhancementMessagesQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ jobId }], signal }: QueryFunctionContext<ReturnType<typeof superEnhancementKeys.messages>>) =>
    call(() => cancelOnSignal(superEnhancementApi.messages(jobId), signal), {
      dontRedirectOnError: true,
      onError: () => {},
    });
